// @flow
import { getJson, postJson } from 'utils/http';

type ApplicantNotification = {
  id: string,
  created: string,
  type: 'NEW_LISTING_APPLICATION',
  about: {
    id: string,
    type: 'ORG'
  },
  data: {
    listingApplication: {
      id: string,
      listing: {
        id: string,
        type: 'JOB' | 'VOLOP' | 'INTERNSHIP',
        name: string
      },
      status: 'NEW',
      newCount: number
    }
  }
};

type ApplicantsByListingNotification = {
  type: 'NEW_APPLICATIONS_BY_LISTING',
  created: string,
  data: {
    id: string,
    applications: Array<{ id: string, notificationId: string }>,
    type: 'JOB' | 'VOLOP' | 'INTERNSHIP',
    name: string,
    orgId: string,
    status: 'NEW',
    count: number,
    newCount: number
  }
};

export type Notification =
  | ApplicantNotification
  | ApplicantsByListingNotification;

export type Notifications = Array<Notification>;

export const fetchNotifications = (): Promise<Array<Notification>> =>
  getJson('/data/notifications').then(({ notifications }) => notifications);

export const dismissNotifications = (notificationIds: Array<string>) =>
  postJson('/data/notifications-read', { notificationIds }).then(
    ({ notifications }) => notifications
  );
